import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import {
    CodeRejet,
    CodeRejetSelector,
    setXIdSociete,
    useAchatsService,
    useSociete,
} from '@europrocurement/l2d-domain';
import { LazyBreadcrumb } from '@europrocurement/flexy-components';
import { DataSource } from '@europrocurement/l2d-redux-utils';

import { AppDispatch } from '../../../../redux/types';

import RejectCodesListComponent from '../../components/lists/RejectCodesListComponent';

const RejectCodesList: React.FunctionComponent = function () {
    const { getCodeRejet } = useAchatsService();

    const codesRejetsDataSource: DataSource<CodeRejet> = useSelector(CodeRejetSelector).main;

    const dispatch = useDispatch<AppDispatch>();
    const xIdSociete = useSociete();

    useEffect(() => {
        if (xIdSociete !== 12) {
            dispatch(setXIdSociete(12));
        }
        dispatch(getCodeRejet({}));
    }, [dispatch, getCodeRejet, xIdSociete]);

    return (
        <>
            <LazyBreadcrumb
                path={[{ path: 'Portail achats', link: '/achats/liste' }, 'Codes Rejets']}
            />
            <RejectCodesListComponent
                filtersControl
                dataSource={codesRejetsDataSource}
                fetchData={getCodeRejet}
            />
        </>
    );
};

export default RejectCodesList;
